const contentData = {
  generic: {
    free: {
      'en-us': 'FREE'
    }
  },
  cart: {
    emptyTextLine1: {
      'en-us': 'Your cart is empty.'
    },
    emptyTextLine2: {
      'en-us': 'Better rest awaits.'
    },
    telephoneText: {
      'en-us': 'Questions? Call: 1-844-335-3372'
    },
    telephoneValue: {
      'en-us': '18443353372'
    },
    telephoneLinkTitle: {
      'en-us': 'Contact Leesa Sleep Customer Service'
    },
    closeButton: {
      'en-us': 'Close'
    },
    cartTitle: {
      'en-us': 'Your Cart'
    },
    subtotal: {
      'en-us': 'Subtotal'
    },
    taxes: {
      'en-us': 'Taxes'
    },
    shipping: {
      'en-us': 'Estimated Shipping'
    },
    calculatedShipping: {
      'en-us': 'Calculated at checkout'
    },
    checkout: {
      'en-us': 'Secure Checkout'
    },
    trashCanAriaLabel: {
      'en-us': 'Remove [QUANTITY] [ITEM] from cart'
    }
  },
  og: {
    image: {
      url: {
        'en-US': '/images/leesa-og-default.jpg'
      }
    }
  },
  skipLink: {
    skipATCButton: {
      'en-us': 'Skip to Add to Cart'
    },
    goToCart: {
      'en-us': 'Go to cart'
    },
    skipToCO: {
      'en-us': 'Skip to Checkout'
    },
    skipToContent: {
      'en-us': 'Skip to Content'
    }
  },
  'en-US': {
    atc: {
      'aria-label': 'Add [SIZE] size [TITLE] to cart for $[PRICE]',
      'aria-label-no-stock': 'Sorry, this product is out of stock',
      'label-default': 'Add to cart',
      'label-multiple': 'Add [QTY] items to cart',
      'label-no-stock': 'Out of Stock',
      name: 'Add',
      'name-no-stock': 'Sold',
      'name-event': 'Adding',
      event: 'Adding'
    },
    oos: {
      singleProductMsg:
        'Sorry, the following item has become out of stock and has been removed from your cart:',
      multiProductMsg:
        'Sorry, the following items have become out of stock and have been removed from your cart:'
    }
  }
};
export default contentData;

/**
 * Topic based revalidation tags meant to be used for caching.
 * These are non route specific tags because you can use revalidatePath() for
 * anything more path / slug specific. You won't need to use these.
 */
export const TAGS = {
  // Source of truth revalidation tags
  contentstack: 'contentstack-v2',
  products: 'products-v2',
  yotpo: 'yotpo-v2',

  // We use this to have our resource guide notice brand new articles
  articleLists: 'article-lists'
};

export const HIDDEN_PRODUCT_TAG = 'nextjs-frontend-hidden';
export const DEFAULT_OPTION = 'Default Title';
export const SHOPIFY_GRAPHQL_API_ENDPOINT = `/api/${process.env.SHOPIFY_STOREFRONT_API_VERSION}/graphql.json`;

export const companyInformation = {
  name: 'Leesa Sleep',
  url: 'https://www.leesa.com',
  siteName: 'Leesa',
  logo: 'https://www.leesa.com/images/leesa-rgb-square-logo-light.svg',
  license: 'https://www.leesa.com/pages/terms-of-use',
  acquireLicensePage: 'https://www.leesa.com/pages/customer-care',
  merchantReturnLink: 'https://www.leesa.com/pages/trial-and-returns',
  address: {
    streetAddress: '5301 W Bethany Home Rd',
    addressLocality: 'Glendale',
    addressRegion: 'AZ',
    addressCountry: 'US',
    postalCode: '85301',
    telephone: '+1-602-783-8190'
  },
  contactPoint: {
    telephone: '+1-844-335-3372',
    contactType: 'Customer Service',
    email: 'support@leesa.com'
  }
};
